import React from 'react';
import './NewPurchaseItem.less';

interface INewPurchaseItemPropType {
    prefixCls?: string;
    data?: any;
    onBtnClick?: (data?: any) => void;
}


class NewPurchaseItem extends React.Component<INewPurchaseItemPropType, any> {
    static defaultProps = {
        prefixCls: 'new-purchaseItem'
    };

    render() {
        const {prefixCls, data, onBtnClick} = this.props;
        return (
            <div className={`${prefixCls}`}>
                <div className={`${prefixCls}-imgBox`}>
                    <img src={data.mastermap} alt=""/>
                </div>
                <div className={`${prefixCls}-context`}>
                    <p className={`${prefixCls}-title`}>{data.productAd}</p>
                    <p className={`${prefixCls}-msg`} style={{WebkitBoxOrient: 'vertical'}}>{data.productName}</p>
                    <div className={`${prefixCls}-showBox`}>
                        <span className={`${prefixCls}-price`}>
                            <i>￥</i>
                            {data.price}
                        </span>
                        <span className={`${prefixCls}-market-price`}>
                            ￥{data.marketPrice}
                            <i/>
                        </span>
                        <div className={`${prefixCls}-btn`} onClick={onBtnClick}>马上抢</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewPurchaseItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/NewPurchaseItem.tsx